import React from "react";

import { Item } from "semantic-ui-react";

import * as moment from "moment";

import { ReimbursementItemImageStyle } from "./PendingReimbursementItem";

const ApprovedReimbursementItem = props => {
  const reimbursement = props.reimbursement;
  return (
    <Item>
      <Item.Image size="tiny" rounded>
        <div
          style={ReimbursementItemImageStyle(reimbursement.image_thumbnail)}
        />
      </Item.Image>

      <Item.Content>
        <Item.Header>{reimbursement.description}</Item.Header>
        <Item.Meta>${(+reimbursement.amount).toFixed(2)}</Item.Meta>
        <Item.Extra>
          {moment(reimbursement.last_action_at).calendar()}
        </Item.Extra>
      </Item.Content>
    </Item>
  );
};

export default ApprovedReimbursementItem;



// WEBPACK FOOTER //
// ./frontend/src/components/ApprovedReimbursementItem.js